// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2OY5o","errorLogs":"EditorFooter_errorLogs__2fSFm"};